export const $settings = {
    currencyFormatting : {
        'EUR': {
            symbol: "€",
            thousandsSeparator: ".",
            fractionCount: 2,
            fractionSeparator: ",",
            symbolPosition: "back",
            symbolSpacing: true
        },
        'USD': {
            symbol: "$",
            thousandsSeparator: ",",
            fractionCount: 2,
            fractionSeparator: ".",
            symbolPosition: "back",
            symbolSpacing: true
        },
        'HKD': {
            symbol: "HK",
            thousandsSeparator: ".",
            fractionCount: 2,
            fractionSeparator: ",",
            symbolPosition: "back",
            symbolSpacing: true
        }
    },
    toasts: {
        'toastDanger': {
            toaster: "b-toaster-top-center",
            solid: true,
            noCloseButton: true,
            variant: 'danger',
            appendToast: false
        },
        'toastSuccess': {
            toaster: "b-toaster-top-center",
            solid: true,
            noCloseButton: true,
            variant: 'success',
            appendToast: false
        }
    }
};